import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import AnnouncementsLayer from "../../components/announcements/AnnouncementsLayer";

const AnnouncementsPage = () => (
  <MasterLayout>
    <Breadcrumb
      routePath="/announcements"
      routeName="Home"
      title="Announcements"
    />
    <AnnouncementsLayer />
  </MasterLayout>
);

export default AnnouncementsPage;
